<div class="d-flex justify-content-around align-items-center flex-wrap">
    <div class="p-2 contact-ph-card" *ngFor="let phnum of phoneNumbers">
        <a href="tel:{{phnum}}">
            <img [src]="phoneImg" alt="phone" class="contact-ph-img">
            <label class="contact-ph-lbl">{{phnum}}</label>
        </a>
    </div>
</div>